import { apiClient } from "../config/api.config";
import { getMedecine360SessionTokenFromStorage } from "../utils/session-utils";

type ValidateSessionResponse = ReturnType<typeof sendValidateSession>;

/**
 * MED-1615: the post-login token is single-use. React StrictMode (dev) mounts the
 * session provider twice, and a second validate-session with the same token is
 * refused (401), which sent the user back to login. Calls made with the same
 * token share one request.
 */
const bearerValidations = new Map<string, ValidateSessionResponse>();

function sendValidateSession(sessionToken: string | null) {
  return apiClient.request({
    method: "post",
    url: "/validate-session",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(sessionToken && { Authorization: `Bearer ${sessionToken}` }),
    },
  });
}

export function requestValidateSession() {
  const sessionToken = getMedecine360SessionTokenFromStorage();
  if (!sessionToken) return sendValidateSession(null);
  const pending = bearerValidations.get(sessionToken);
  if (pending) return pending;
  const request = sendValidateSession(sessionToken);
  bearerValidations.set(sessionToken, request);
  return request;
}

export function requestGetSession() {
  return apiClient.request({
    method: "get",
    url: "/session",
  });
}

export function requestTerminateSession() {
  return apiClient.request({
    method: "get",
    url: "/logout",
  });
}
